export const qwertz = ['Q', 'W', 'E', 'R', 'T', 'Z', 'U', 'I', 'O', 'P'];
export const asdf = ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'];
